export const formatPln = (value: number): string => {
  const [intPart, decimalPart] = value.toFixed(2).split('.')
  return `${intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')},${decimalPart} PLN`
}
